export const authkey = "Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJDbGFpbXMiOnsiVG5FIjoiV2ViQVBJIn0sIkVJRCI6IjE0MzAiLCJpYXQiOjE3NDgzMzY5NzIsImV4cCI6MTc0ODQyMzM3Mn0.Qi2DZgdWsAVBs3QGHyVwUfnc8Gmz36nreDZbeLJqOjU; FedAuth=77u/PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz48U2VjdXJpdHlDb250ZXh0VG9rZW4gcDE6SWQ9Il8zZTdlMjZlNC1iYjc1LTQ5YmYtYjEzNS0xNGRjOTU5YTgxOWEtQjFCMDMxRTNEMUMxNzVEQUQ3NjEwQkI3MTExRjc5OTIiIHhtbG5zOnAxPSJodHRwOi8vZG9jcy5vYXNpcy1vcGVuLm9yZy93c3MvMjAwNC8wMS9vYXNpcy0yMDA0MDEtd3NzLXdzc2VjdXJpdHktdXRpbGl0eS0xLjAueHNkIiB4bWxucz0iaHR0cDovL2RvY3Mub2FzaXMtb3Blbi5vcmcvd3Mtc3gvd3Mtc2VjdXJlY29udmVyc2F0aW9uLzIwMDUxMiI+PElkZW50aWZpZXI+dXJuOnV1aWQ6NzRlMzZkNDItNTg4NS00M2VmLWExZjAtYzgzN2VjOGJlNjUxPC9JZGVudGlmaWVyPjxDb29raWUgeG1sbnM9Imh0dHA6Ly9zY2hlbWFzLm1pY3Jvc29mdC5jb20vd3MvMjAwNi8wNS9zZWN1cml0eSI+aHpWOE1LSWgxY01OemR4b25URUFHMWVBZ3BBeDNrWklLQ3dFOThERDdrdlg3ZmFKSUMwTHFoNXhtNU1GU1daWDZjV05yOFcvbFNlVTZMYW9QUGlLRDVaMU1jSzR4NW5OUzk2dEF0QkpqUmVldUVxOGRjdUtMU2dvd3RHU3phZkYrS3lVeDA3ZEpoNFZXNGdpY244dWpCSENDRjRHVzcvcDRSbDdzOXVLamxYbEpRc2p0ajlDWU11ZnhYMlk4Y3JNdjdXcTZ6NjVyTnFqbXFlTVRKeWZpZXhvUFpCc21zcWU3eVlBSnlHRjhNcTVSNm5DZTVsNXpjaS95K0ZyZmxleVhOaGFQUllrNHZHaVdGdnhQbjdTdVZUQnFpc2RNTW5UcHE0MldWZ2JEMDBxTnlVUzNYRDQvQ0NiNVJ3SmN4UnlnL0ZqTkJLTDRLT1ExTXJ2NFg2RjB4Ym5GZ1JOaUlsRjkrUkM2d3ZvbWxPUEFRRmV4YmxrY2lIelh1MFhZYk8zcyswSUs5TkZLeUxqNjZyVFA5WkZOaG9QOXhsZmtCVSswcnd6QW01Sko2MmhnbG5BeXNaQVVTMTFOSkF5QmZHUHNwRGQ1b3ZQVGZsMHd4dzhXaEkxTTZRckliQko0czFrZE5YTTQ0U3pHNGR2NU0vSDh0N1lmbkx6eStwZHp3eGFLQisySWdPSXFwb0lKbmNrS284N3hsNXdXUlNHeFpqSm9FRjBzcmxLbG9GVzQ0b1FNa0hSMElDeFQ3bzlZelQ1VWNWelBaRzBNQlgxN2I4MWN3QmFzVkxmSG1TTjcvYzNQUWVEcC9vNDM0bXhacHhnZitIall1d1N1aHdkdU45MWhLcTNYY3RHTFhPV1FvclZmVEtUTjcvZkdHWEEwc3pUV1AzSXdVUHF2dVlWZFFOZ2lrL0JrQjRKTkIyNURYbzRTbzFRNmo1OGxDREJDNDZQUWtsdlhSYm11WWVaTzZGL0lpSnhCdnZ3SlBiL1o4Z2s3ckprSGx6VW1WT096VDlUcE9OdUxtQXFwYTF6elpBSTRMNVNMUT09PC9Db29raWU+PC9TZWN1cml0eUNvbnRleHRUb2tlbj4="
export const keywords = [
    "EMPLOYEENAME", 
				"EMPLOYMENTNUMBER", 
				"HRMSLOGINID", 
				"DESIGNATION", 
				"LOCATION",
				"CREATORNAME",
				"CREATORID",
				"BYDATE",
				"FORMNAME",
				"ORGANIZATIONUNIT",
				"PERIOD",
				"TABLEPLACEHOLDER",
				"REQUESTSTATUS",
				"ARSTATUS",
				"REASON",
				"CATEGORY",
				"TABLEPLACEHOLDER_FOR_AR",
				"ARDURATION",
				"FROMDATE",
				"TODATE"
];

export const keywordValues = {
	"EMPLOYEENAME": "Amit Deshmukh", 
	"EMPLOYMENTNUMBER": "01993", 
	"HRMSLOGINID": "amit.deshmukh@thedigitalgroup.com", 
	"DESIGNATION": "Senior Software Engineer", 
	"LOCATION": "Pune",
	"CREATORNAME": "Vinu",
	"CREATORID": "01211",
	"BYDATE": "08/05/2025",
	"FORMNAME": "AR Approval",
	"ORGANIZATIONUNIT": "001",
	"PERIOD": "08/05/2025 - 15/05/2025",
	"ARDURATION": "08/05/2025 - 15/05/2025",
	"TABLEPLACEHOLDER": "",
	"REQUESTSTATUS": "Pending",
	"ARSTATUS": "Pending",
	"REASON": "Reason for status",
	"CATEGORY": "AR ",
	"TABLEPLACEHOLDER_FOR_AR": "",
	"FROMDATE": "04/05/20250",
	"TODATE": "05/05/20250",
	
	
};

export const pagesPerModule = {
	1: [
		"BankMaster",
		"BirthdayNotification",
		"EmployeeLetters",
		"EmployeeRetirementNotification",
		"EmploymentTypeChange",
		"EmploymentTypeMaster",
		"GradeMaster",
		"LocationMaster",
		"MyDetails",
		"SetDesignations",
		"SkillCategories",
		"WorkAnniversaryNotification"
	],
	4: [],
	5: [
		"TR-AdhocTraining",
		"TR-AssignTraining",
		"TR-CancelTraining",
		"TR-CancelTrainingInvite",
		"TR-ChangeInTraining",
		"TR-EmployeeSubmitExternalTrainings",
		"TR-EvaluateTraining",
		"TR-ExternalTrainings",
		"TR-ExternalTrainingsRejection",
		"TR-FeedbackReminder",
		"TR-MandatoryTrainingReminder",
		"TR-NominateTraining",
		"TR-OnlineTrainingReminder",
		"TR-PendingApprovalReminder",
		"TR-PostAssessment",
		"TR-PostAssessmentNotification",
		"TR-PostAssessmentReminder",
		"TR-PreAssessment",
		"TR-PreAssessmentNotification",
		"TR-PreAssessmentReminder",
		"TR-PublishTNI",
		"TR-PublishTraining",
		"TR-RecommendedTraining",
		"TR-RecommendReTraining",
		"TR-TNIEmployeeSubmitReminder",
		"TR-TNIManagerSubmitReminder",
		"TR-TrainerFeedbackReminder",
		"TR-TrainingCalendar",
		"TR-TrainingInvite",
		"TR-TrainingTeamSurvey",
		"TR-WaiverReminder"
	],
	6: [
		"ItineraryRequest",
		"MoreItineraryRequest",
		"TravelAccommodationBooked",
		"TravelAdvancePayment",
		"TravelChangeRequest",
		"TravelRequest",
		"TravelRequestAcknowledged",
		"TravelRequestComplete",
		"TravelRequestComplete-HR",
		"TravelRequestInternational",
		"TravelTicketBooked",
		"TravelTicketUploaded"
	],
	7: [
		"ExpensePayment",
		"ExpenseRequest",
		"ExpenseRequestAcknowledged",
		"ExpenseRequestComments",
		"ExpenseRequestComplete",
		"ExpenseRequestPartsSales",
		"ExpenseRequestProject",
		"ExpenseRequestSplit",
	],
	8: [
		"BudgetApproval",
		"CandidateFilledByRecruiter",
		"CandidateFilledByRecruiterToRecruiter",
		"CandidateInterviewInvite",
		"CandidateJoining",
		"CandidateLinkInitiateToRecruiter",
		"CandidateLinkInitiation",
		"CandidateOfferLetterEmail",
		"CandidateOnHoldReminderEmail",
		"CandidateRefillDocuments",
		"CandidateRefillToRecruiter",
		"CandidateScheduleInterview",
		"CandidatesRecruitmentApprovalNotification",
		"CandidatesRecruitmentOnHoldNotification",
		"CandidatesRecruitmentRejectionNotification",
		"CandidateSubmitToRecruiter",
		"DocumentBuilderRecruitment",
		"InitiateHiring",
		"InterviewFeedback",
		"OfferAcceptIntimationToRecruiter",
		"OfferAcceptRejectByCandidate",
		"OfferLetterIntimation",
		"OfferLetterIntimationToRecruiter",
		"OfferPendingForReview",
		"OfferRejectIntimationToRecruiter",
		"OfferValidityIntimationToRecruiter",
		"PreOfferRecruiterStatus",
		"RecruitmentInformationCollection",
		"RecruitmentManagement",
		"RRSAllocation",
		"RRSBillingDueDateNotification",
		"RRSCancellation",
		"RRSCandidateReferral",
		"RRSCloserDueDateNotification",
		"RRSInterviewReschedule",
		"RRSJobPosting",
		"RRSPositionAction",
		"ScheduleInterview",
		"ShortlistedCandidate"
	],
	9: ["TimePort"],
	10: [
		"EmployeeAssessmentFinalScore",
		"EmployeeGoalSettingAcknowledge",
		"EmployeeGoalSettingInit",
		"EmployeeGoalSettingReassign",
		"EmployeeGoalSettingUpdate",
		"EmployeeReEnlistment",
		"EmployeeRetirement",
		"GoalSetting",
		"PerformanceManagement",
		"SelfAssessment",
		"ViewAssessments",
	],
	11: [
		"Policy Documents Setup",
		"PolicyDocumentActivation",
		"PolicyDocumentSignOffConfirmation",
		"SelfAttestation"
	],
	12: [
		"AdminHelpDeskSubmitted",
		"AdminHelpDeskUpdated",
		"BusinessCard",
		"DocumentBuilderESS",
		"ESSSendEmailReminder",
		"ESSSendOverDueEmail",
		"FinanceHelpDeskSubmitted",
		"FinanceHelpDeskUpdated",
		"HelpdeskSubmitted",
		"HelpdeskUpdated",
		"ISHelpDeskSubmitted",
		"ISHelpDeskUpdated",
		"PendingEmployeeDocumentApproval_ReminderAlert",
		"ReminderHelpdeskNotificaiton",
		"VoucherApplied",
		"VoucherAppliedCancellation",
		"VoucherClosure",
		"VoucherInitiatedCancellation",
		"VoucherInitiation",
	],
	13: [
		"EmployeeF&F",
		"EmployeeSeparation",
		"ResignationActivity",
		"ResignationDetails",
		"ResignationMaster",
		"ResignationPullback",
		"SeparationRequestReroute",
	],
	14: [],
	15: [
		"RA-AllocationEndReminder",
		"RA-AllocationUpdate",
		"RA-ApproveRAProvider",
		"RA-AvailableRellocation",
		"RA-ConfirmAllocation",
		"RA-FreezeNotificationtoManager",
		"RA-FreezeUnFreeze",
		"RA-InitiateReallocation",
		"RA-PublishRAS",
		"RA-PullBackInitiateReallocation",
		"RA-RASPublishReminder",
		"RA-RASPublishStatus",
		"RA-UnFreezeRequest",
	],
	16: [],
	17: [
		"SR-AnonymousSurvey",
		"SR-ConfidentialSurvey"
	],
	18: [
		"BGVCandidateDocUpload",
		"DeactivationEmployeeDialog",
		"DirectCandidate",
		"EmployeeCreation",
		"EmployeeDetails",
		"EmployeeSummaryPermissions",
		"EmployeeWelcomeMail",
		"PostEmpBackgroundVerification",
		"PostEmpBGVExtend",
		"PreEmpBackgroundVerification",
		"PreEmpBGVExtend",
		"PreOnboardingCandidateApproved",
		"PreOnboardingCandidateClosed",
		"PreOnboardingCandidateInformation",
		"PreOnboardingCandidateInitiation",
		"PreOnboardingCandidateLinkInitiatedResent",
		"PreOnboardingCandidatePendingForReview",
		"PreOnboardingExpectedDOJUpdate",
		"PreOnboardingExpectedDOJUpdateInternal",
		"ReactivationEmployeeDialog",
	],
	19: [
		"EmployeeLocked",
		"HolidayMaster",
		"InOutNotification",
		"NewsAndEvents",
		"OptionalHolidayMaster",
		"RoleAccessRightManagement",
		"RolesPermissions",
		"UserAccessRightManagement",
		"UsersPermissions",
		"WorkflowGroup",
	],
	20: [
		"ARCancellation",
		"ARReminders",
		"AttendanceCategory",
		"AttendanceNotification",
		"AttendanceOverTime",
		"AttendanceRegularize",
		"AttendanceRegularize-WFH",
		"CalendarMaster",
		"CompOffCreditRequest",
		"CompOffRequest",
		"CreateLeaveType",
		"EmployeeAnnualLeaveExceed",
		"LeaveCancellation",
		"LeaveCreditRules",
		"LeaveLimitExceedsNotification",
		"LeaveRequest",
		"ManagerNotification",
		"OptionalHolidayCancellation",
		"OptionalHolidayRequest",
		"RequestReroute",
		"ShiftMaster",
		"WeeklyOffMaster",
		"WFHCancellation",
	],
	21: [],
	22: [],
	23: [
		"AllocationOfOrganizationalAsset",
		"DeAllocationOfOrganizationalAsset"
	],
	26: [
		"ConfirmationAssessment",
		"ConfirmationManagement",
		"EmployeeConfirmation"
	],
	27: [
		"PolicyDocumentAttestation"
	],
	28: [],
	29: [
		"AdvanceRequest"
	],
	30: []
}

export const moduleListMulti = [
	{
		value: "My Details",
		label: "My Details",
		selected: false,
		modulePages: [
			{
				name: "EmploymentTypeChange",
				workflow: [
					{name: "Employee information updation"}
				]
			},
			{
				name: "My Details",
				workflow: [
					{name: "My Details"}
				]
			}
		]
	},
	{
		value: "Attendance Regularization", 
		label: "Attendance Regularization", 
		selected: false,
		modulePages: [
			{
				name: "ARCancellation",
				workflow: [
					{name: "AR Cancellation"}
				]
			},
			{
				name: "ARReminders",
				workflow: [
					{name: "AR Reminders - SG"}
				]
			},
			{
				name: "AttendanceRegularize",
				workflow: [
					{name: "Attendance Regularization"}
				]
			},
		]
	},
	{
		value: "Leave Management", 
		label: "Leave Management", 
		selected: false,
		modulePages: [
			{
				name: "CompOffCreditRequest",
				workflow: [
					{name: "Comp Off Credit Request"}
				]
			},
			{
				name: "CompOffRequest",
				workflow: [
					{name: "compoff request by employee"}
				]
			},
			{
				name: "LeaveCancellation",
				workflow: [
					{name: "LeaveCancellation"}
				]
			},
			{
				name: "LeaveRequest",
				workflow: [
					{name: "Leave Request"}
				]
			},
		]
	},
	{
		value: "Payroll", 
		label: "Payroll", 
		selected: false,
		modulePages: []
	},
	{
		value: "Training", 
		label: "Training", 
		selected: false,
		modulePages: [
			{
				name: "TR-AdhocTraining",
				workflow: [
					{name: "Training Adhoc Request"}
				]
			},
			{
				name: "TR-AssignTraining",
				workflow: [
					{name: "Training Assignment Workflow"}
				]
			},
			{
				name: "TR-CancelTraining",
				workflow: [
					{name: "Training Cancellation"}
				]
			},
			{
				name: "TR-CancelTrainingInvite",
				workflow: []
			},
			{
				name: "TR-ChangeInTraining",
				workflow: [
					{name: "Training Changes Workflow"}
				]
			},
			{
				name: "TR-EmployeeSubmitExternalTrainings",
				workflow: [
					{name: "Training Employee Submit External Trainings"}
				]
			},
			{
				name: "TR-EvaluateTraining",
				workflow: [
					{name: "Evaluate Trainings"}
				]
			},
			{
				name: "TR-ExternalTrainings",
				workflow: [
					{name: "External Trainings"}
				]
			},
			{
				name: "TR-ExternalTrainingsRejection",
				workflow: [
					{name: "External Trainings Rejection"}
				]
			},
			{
				name: "TR-FeedbackReminder",
				workflow: [
					{name: "Feedback Reminder"}
				]
			},
			{
				name: "TR-MandatoryTrainingReminder",
				workflow: [
					{name: "Mandatory Training Reminder"}
				]
			},
			{
				name: "TR-NominateTraining",
				workflow: [
					{name: "Nominate Training"}
				]
			},
			{
				name: "TR-OnlineTrainingReminder",
				workflow: [
					{name: "Online Training Reminder"}
				]
			},
			
		]
	},
	{value: "Travel", label: "Travel", selected: false, modulePages: []},
	{value: "Expense & Reimbursement", label: "Expense & Reimbursement", selected: false, modulePages: []},
	{value: "Recruitment", label: "Recruitment", selected: false, modulePages: []},
	{value: "Timeport", label: "Timeport", selected: false, modulePages: []},
	{value: "Performance Assessment", label: "Performance Assessment", selected: false, modulePages: []},
	{value: "Policy Documents", label: "Policy Documents", selected: false, modulePages: []},
	{value: "Employee Self Service", label: "Employee Self Service", selected: false, modulePages: []},
	{value: "Separation", label: "Separation", selected: false, modulePages: []},
	{value: "Reports & Analytics", label: "Reports & Analytics", selected: false, modulePages: []},
	{value: "Resource Allocation", label: "Resource Allocation", selected: false, modulePages: []},
	{value: "Conference Room Booking", label: "Conference Room Booking", selected: false, modulePages: []},
	{value: "Survey", label: "Survey", selected: false, modulePages: []},
	{value: "Employee Management & Pre-Onboarding", label: "Employee Management & Pre-Onboarding", selected: false, modulePages: []},
	{value: "Admin Configuration", label: "Admin Configuration", selected: false, modulePages: []},
	{value: "Leave & Attendance", label: "Leave & Attendance", selected: false, modulePages: []},
	{value: "Mobile App", label: "Mobile App", selected: false, modulePages: []},
	{value: "User Manual", label: "User Manual", selected: false, modulePages: []},
	{value: "Policy Document Attestation", label: "Policy Document Attestation", selected: false, modulePages: []},
	{value: "Violations & Occurrence", label: "Violations & Occurrence", selected: false, modulePages: []},
	{value: "Advances", label: "Advances", selected: false, modulePages: []}
]

export const moduleList = {
"My Details": [{"EmploymentTypeChange": ["Employee information updation"], "MyDetails": ["My Details"]}],
"Attendance Regularization": ["ARCancellation", "ARReminders", "AttendanceRegularize"],
"Leave Management": ["CompOffCreditRequest", "CompOffRequest", "EmployeeAnnualLeaveExceed", "LeaveCancellation"],
"Payroll": [],
"Training": ["TR-CancelTraining", "TR-CancelTrainingInvite", "TR-ChangeInTraining", "TR-EmployeeSubmitExternalTrainings"],
"Travel": ["ItineraryRequest", "MoreItineraryRequest", "TravelAccommodationBooked", "TravelAdvancePayment", "TravelChangeRequest"],
"Expense & Reimbursement": [],
"Recruitment": [],
"Timeport": [],
"Performance Assessment": [],
"Policy Documents": [],
"Employee Self Service": [],
"Separation": [],
"Reports & Analytics": [], 
"Resource Allocation": [],
"Conference Room Booking": [],
"Survey": [],
"Employee Management & Pre-Onboarding": [],
"Admin Configuration": [],
"Leave & Attendance": [],
"Mobile App": [],
"User Manual": [],
"Asset Management": [],
"Confirmation Assessment": [],
"Policy Document Attestation": [],
"Violations & Occurrence": [],
"Advances": []
}

export const modulePages = [
	"EmploymentTypeChange",
	"MyDetails",
	"ARCancellation", "ARReminders", "AttendanceRegularize",
	"TR-CancelTraining", "TR-CancelTrainingInvite", "TR-ChangeInTraining", "TR-EmployeeSubmitExternalTrainings",
	"ItineraryRequest", "MoreItineraryRequest", "TravelAccommodationBooked", "TravelAdvancePayment", "TravelChangeRequest"
]

export const formType = [
	{name: "Select Type", category: "", id: 1},
	{name: "Notification Only", category: "N", id: 2},
	{name: "Notification for Approvers", category: "N", id: 3},
	{name: "Notification for Pullback", category: "N", id: 4},
	{name: "Transaction(Approve)", category: "T", id: 5},
	{name: "Transaction(Reject)", category: "T", id: 6}
]

export const workflow = [
	"My Details",
	"Employee information updation",
	"AR cancellation",
	"AR Reminder - SG",
	"Transaction(Reject)"
];

export const workflowTestData = [
                {
                    key: '0',
                    label: 'My Details',
                    data: 'Details',
                    children: [
                        {
                            key: '0-0',
                            label: 'Level1',
                            data: 'Level1',
                            children: [
                                { 
                                    key: '0-0-0', 
                                    label: 'Notifications', 
                                    data: 'Notifications',
                                    children: [
                                        {key: '0-0-0-0', label: "HR", data: 'HR'},
                                        {key: '0-0-0-1', label: "Initiator", data: 'Initiator'},
                                    ] 
                                },
                                { 
                                    key: '0-0-1', 
                                    label: 'Approver', 
                                    data: 'Approver',
                                    children: [
                                        {key: '0-0-0-0', label: "HR", data: 'HR'},
                                        {key: '0-0-0-1', label: "CEOOOOOO", data: 'CEOOOOOO'},
                                        {key: '0-0-0-1', label: "CEO", data: 'CEO'},
                                    ] 
                                }
                            ]
                        },
                        {
                            key: '0-1',
                            label: 'NOTIFY APPROVAL',
                            data: 'NOTIFY APPROVAL',
                            children: [
                                { 
                                    key: '0-1-0', 
                                    label: 'Notifications',  
                                    data: 'Notifications',
                                    children: [
                                        {key: '0-1-0-0', label: "HR", data: 'HR'},
                                        {key: '0-1-0-1', label: "Initiator", data: 'Initiator'},
                                    ] 
                                }
                            ]
                        },
                        {
                            key: '0-2',
                            label: 'NOTIFY REJECTION',
                            data: 'NOTIFY REJECTION',
                            children: [
                                { 
                                    key: '0-2-0', 
                                    label: 'Notifications',  
                                    data: 'Notifications',
                                    children: [
                                        {key: '0-2-0-0', label: "HR", data: 'HR'},
                                        {key: '0-2-0-1', label: "Initiator", data: 'Initiator'},
                                    ] 
                                }
                            ]
                        },
                        {
                            key: '0-3',
                            label: 'NOTIFY PULLBACK',
                            data: 'NOTIFY PULLBACK',
                            children: [
                                { 
                                    key: '0-3-0', 
                                    label: 'Notifications',  
                                    data: 'Notifications',
                                    children: [
                                        {key: '0-3-0-0', label: "HR", data: 'HR'},
                                        {key: '0-3-0-1', label: "Initiator", data: 'Initiator'},
                                    ] 
                                }
                            ]
                        }
                    ]
                }
            ];

export const workflowTreeData =  [
                {
                    key: '0',
                    label: 'Documents',
                    data: 'Documents Folder',
                    icon: 'pi pi-fw pi-inbox',
                    children: [
                        {
                            key: '0-0',
                            label: 'Work',
                            data: 'Work Folder',
                            icon: 'pi pi-fw pi-cog',
                            children: [
                                { key: '0-0-0', label: 'Expenses.doc', icon: 'pi pi-fw pi-file', data: 'Expenses Document' },
                                { key: '0-0-1', label: 'Resume.doc', icon: 'pi pi-fw pi-file', data: 'Resume Document' }
                            ]
                        },
                        {
                            key: '0-1',
                            label: 'Home',
                            data: 'Home Folder',
                            icon: 'pi pi-fw pi-home',
                            children: [{ key: '0-1-0', label: 'Invoices.txt', icon: 'pi pi-fw pi-file', data: 'Invoices for this month' }]
                        }
                    ]
                },
                {
                    key: '1',
                    label: 'Events',
                    data: 'Events Folder',
                    icon: 'pi pi-fw pi-calendar',
                    children: [
                        { key: '1-0', label: 'Meeting', icon: 'pi pi-fw pi-calendar-plus', data: 'Meeting' },
                        { key: '1-1', label: 'Product Launch', icon: 'pi pi-fw pi-calendar-plus', data: 'Product Launch' },
                        { key: '1-2', label: 'Report Review', icon: 'pi pi-fw pi-calendar-plus', data: 'Report Review' }
                    ]
                },
                {
                    key: '2',
                    label: 'Movies',
                    data: 'Movies Folder',
                    icon: 'pi pi-fw pi-star-fill',
                    children: [
                        {
                            key: '2-0',
                            icon: 'pi pi-fw pi-star-fill',
                            label: 'Al Pacino',
                            data: 'Pacino Movies',
                            children: [
                                { key: '2-0-0', label: 'Scarface', icon: 'pi pi-fw pi-video', data: 'Scarface Movie' },
                                { key: '2-0-1', label: 'Serpico', icon: 'pi pi-fw pi-video', data: 'Serpico Movie' }
                            ]
                        },
                        {
                            key: '2-1',
                            label: 'Robert De Niro',
                            icon: 'pi pi-fw pi-star-fill',
                            data: 'De Niro Movies',
                            children: [
                                { key: '2-1-0', label: 'Goodfellas', icon: 'pi pi-fw pi-video', data: 'Goodfellas Movie' },
                                { key: '2-1-1', label: 'Untouchables', icon: 'pi pi-fw pi-video', data: 'Untouchables Movie' }
                            ]
                        }
                    ]
                }
            ];